<script>
    import Visita from "./Visita.svelte";
</script>

<div class="title">
    Visite
</div>

<Visita 
    testo={"Colosseo"} 
    datetime={"2023-12-30T11:30:00"} 
    biglietti={8} 
    foto={"https://aws-tiqets-cdn.imgix.net/images/content/d2f5c812aa374c3285776a123cf400b6.jpg?auto=format&dpr=1&fit=crop&h=280&ixlib=python-3.2.1&q=40&w=280&s=2757fed5b945820bb0cbb80ff77c09d7"}
/>
<Visita 
    testo={"Cena da iClementini"} 
    datetime={"2023-12-30T19:30:00"} 
    biglietti={8} 
    foto={"https://menu.sluurpy.it/foto-g/141225/2549706.jpg"}
/>
<Visita 
    testo={"Catacombe di S. Callisto"} 
    datetime={"2023-12-31T11:00:00"} 
    biglietti={8} 
    foto={"https://aws-tiqets-cdn.imgix.net/images/content/a186e4fc0bb54def9c4d9649bc53e8e9.jpg?auto=format&dpr=1&fit=crop&h=280&ixlib=python-3.2.1&q=40&w=280&s=e11da714977a3156b0cdcf8195d64d28"}
/>
<Visita 
    testo={"Christmas World @Villa Borghese"} 
    datetime={"2023-12-31T14:00:00"} 
    biglietti={8} 
    foto={"https://www.ansa.it/webimages/ch_700/2022/11/30/141fd2cc7e09cc58d48e9795fc7b63dd.jpg"}
/>
<Visita 
    testo={"Vaticano ???"} 
    datetime={"2024-01-01T11:00:00"} 
    biglietti={0} 
    foto={"https://curiosandoingiro.com/wp-content/uploads/2022/05/b20211228_171608.jpg"}
/>
<Visita 
    testo={"Quartiere Trevi Sotterranei: acquedotto Domus"} 
    datetime={"2024-01-02T11:30:00"} 
    biglietti={8} 
    foto={"https://aws-tiqets-cdn.imgix.net/images/content/9dd9ebd5fa6d49c598b7242301e7db14.jpg?auto=format&dpr=1&fit=crop&h=280&ixlib=python-3.2.1&q=40&w=280&s=7624eaa1ffbc0738368aacf27fa34aee"}
/>
<Visita 
    testo={"Cena @La vecchia Roma"} 
    datetime={"2024-01-02T19:30:00"} 
    biglietti={8} 
    foto={"https://images.getrecipekit.com/20230608125607-pasta-carbonara-1.JPG?aspect_ratio=1:1&quality=90&"}
/>
<Visita 
    testo={"Pantheon, Roma: Biglietto saltafila + Audioguida"} 
    datetime={"2024-01-03T11:30:00"} 
    biglietti={8} 
    foto={"https://aws-tiqets-cdn.imgix.net/images/content/66efa0af38c94399aafd6a171a245552.jpeg?auto=format&dpr=1&fit=crop&h=280&ixlib=python-3.2.1&q=40&w=280&s=68c51de100359bf25426f5090d9e3e5a"}
/>

<style>
        .title {
        font-size: 3.5em;
        font-weight: bold;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        margin: 1em;
        text-align: center;
    }
</style>